import React, { PureComponent } from 'react';
import classNames from 'classnames';
import Dropdown from 'components/base/Dropdown';
import SVG from 'components/base/SVG';

import css from './style.scss';
import PropTypes from 'prop-types';
import infoGreen from 'assets/images/account-page/info-green.svg';
import nationalDncIcon from 'assets/images/national-dnc.svg';
import addGreen from 'assets/images/add-contact-button.svg';
import addGreenHover from 'assets/images/add-contact-button-hover.svg';
import addGreenPressed from 'assets/images/add-contact-button-pressed.svg';
import remove from 'assets/images/remove-contact-button.svg';
import removeHover from 'assets/images/remove-contact-button-hover.svg';
import removePressed from 'assets/images/remove-contact-button-pressed.svg';
import Select from '../../../components/Select';

class ContactItems extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isConfidenceScorePopupOpen: false
    };

    this.closeInfoPopupTimeout = null;
    this.handleAdd = this.handleAdd.bind(this);
    this.toggleConfidenceScorePopup = this.toggleConfidenceScorePopup.bind(this);
    this.openInfoPopup = this.openInfoPopup.bind(this);
    this.scheduleCloseInfoPopup = this.scheduleCloseInfoPopup.bind(this);
    this.cancelCloseInfoPopup = this.cancelCloseInfoPopup.bind(this);
  }

  componentWillUnmount() {
    if (this.closeInfoPopupTimeout) {
      clearTimeout(this.closeInfoPopupTimeout);
      this.closeInfoPopupTimeout = null;
    }
  }

  openInfoPopup() {
    this.cancelCloseInfoPopup();
    this.setState({ isOpen: true });
  }

  scheduleCloseInfoPopup() {
    this.cancelCloseInfoPopup();
    // Small delay prevents flicker moving icon -> tooltip
    this.closeInfoPopupTimeout = setTimeout(() => {
      this.closeInfoPopupTimeout = null;
      this.setState({ isOpen: false });
    }, 120);
  }

  cancelCloseInfoPopup() {
    if (this.closeInfoPopupTimeout) {
      clearTimeout(this.closeInfoPopupTimeout);
      this.closeInfoPopupTimeout = null;
    }
  }

  setItems(newItems) {
    const { field, onChange } = this.props;
    onChange({ name: `${field}s`, value: newItems });
  }

   toggleConfidenceScorePopup() {
    this.setState(prevState => ({
      isConfidenceScorePopupOpen: !prevState.isConfidenceScorePopupOpen
    }));
  }

  handleAdd() {
    const { items, types, field } = this.props;
    if (!types || types.length === 0) {
      // No available types; avoid adding an item without a valid type
      return;
    }

    const newItems = items && items?.length ? items?.slice() : [];
    const seq = items?.reduce((seq, i) => Math.max(seq, i.seq), -1) + 1;

    newItems.unshift({
      type: types[0].value,
      [field]: '',
      seq,
      publicDNC: false,
      dncPab: null,
    });

    this.setItems(newItems);
  }

  handleRemove(seq) {
    const items = this.props.items?.length ? this.props.items?.slice() : [];
    items.splice(seq, 1);

    this.setItems(items);
  }

  handleChange(item, seq, ev, sanitizePhone = false) {
    const { name, value } = ev.target || ev;
    const items = this.props.items?.length ? this.props.items?.slice() : [];
    // Mirrors the signup page's onPhoneInput: digits only, capped at 10.
    const nextValue = sanitizePhone ? value.replace(/\D/g, '').slice(0, 10) : value;
    items[seq] = { ...items[seq], [name]: nextValue };

    if (ev.stopPropagation) ev.stopPropagation();

    this.setItems(items);
  }

  render() {
    const { items, types, field, title, pabEnabled } = this.props;
    const { isConfidenceScorePopupOpen } = this.state;

    return (
      <div className={css.items}>
        <div className={css.itemsHeader}>
          <div className={css.itemsTitle}>{title}{items?.length ? ` (${items?.length})` : ''}
          {field === 'phone'?
            <div className={css.clsInfoPopup}
            >
                <span
                  className={css.clsInfoIcon}
                  onMouseEnter={this.openInfoPopup}
                  onMouseLeave={this.scheduleCloseInfoPopup}
                  onClick={() =>
                  this.setState(prev => ({
                    isOpen: !prev.isOpen,
                      disableHover: false
                  }))
                }
                >
                <img className={css.clsInfoIconImg} src={infoGreen} alt="info" />
              </span>
              <div className={classNames(css.clsInfoPopupContent, {
                  [css.open]: this.state.isOpen
                })}
                onMouseEnter={this.cancelCloseInfoPopup}
                onMouseLeave={this.scheduleCloseInfoPopup}
              >
                  <h5 className={css.clsInfoContentTitle}>
                    Contact Priority
                    <span className={css.clsCloseIcon} onClick={(e) => {
                      e.stopPropagation();
                      this.setState({ isOpen: false, disableHover: false });
                    }}>&times;</span>
                  </h5>
                <p className={css.clsInfoContentPara}>
                  The Contact Priority provides the recommended calling order. Call the top-ranked number first to begin your outreach.
                </p>
              </div>
            </div> : null}
          </div>

          <img
            className={css.icon}
            style={{ paddingLeft: "16px" }}
            onClick={this.handleAdd}
            src={addGreen}
            alt="add"
            onMouseEnter={(e) => { e.currentTarget.src = addGreenHover; }}
            onMouseLeave={(e) => { e.currentTarget.src = addGreen; }}
            onMouseDown={(e) => { e.currentTarget.src = addGreenPressed; }}
            onMouseUp={(e) => { e.currentTarget.src = addGreenHover; }}
          />
        </div>
        {items && items.length > 0  &&
        <div className={classNames(css.headerRow,{ [css.noMarginLeft]: field === 'email' } )}>
          <div className={css.typeHeader}>
            <span>Type</span>
          </div>
          <div className={css.inputHeader}>
            <span>{field === 'phone' ? 'Number' : 'Email Address'}</span>
          </div>
         
          {field === 'phone' && (
            <div className={css.dncHeader}>
              <span>DNC</span>
            </div>
          )}
        </div>
        }
        {items?.map((i, seq) => {
          const isDisabled = field === 'phone' && i.publicDNC;

          return (
          <div className={classNames(css.item, css[field])} key={i.seq}>
              <Select name="type"
                lists={types}
                selectedValue={i.type}
                valueKey="value"
                labelKey="label"
                onSelect={ev => this.handleChange(i, seq, ev)}
                dropdownStyle={css.type}
                inputStyle={{width:'60px'}}
                autoFlip
              />
            <div className={css.inputContainer}>
              <input
                type="text"
                name={field}
                value={i[field]}
                onChange={ev => this.handleChange(i, seq, ev, field === 'phone')}
                className={classNames(css.input, { [css.inputDisabled]: isDisabled })}
                disabled={isDisabled}
              />
            </div>
            {field !== 'phone' ? null : (() => {
              const dncPab = i.dncPab || '';
              const hasMyDNC = dncPab.includes('D');
              const hasPAB = dncPab.includes('A');

              const handleToggleMyDNC = () => {
                const nextHasMyDNC = !hasMyDNC;
                let next = '';
                if (nextHasMyDNC) next += 'D';
                if (hasPAB) next += 'A';
                if (!next) next = null;

                this.handleChange(i, seq, {
                  target: { name: 'dncPab', value: next },
                });
              };

              return (
                <div className={css.dnc}>
                  {i.publicDNC ? (
                    <div className={css.dncPill}>
                      <img
                        src={nationalDncIcon}
                        alt="Public DNC"
                        className={css.dncPillIcon}
                      />
                      <span className={css.dncPillLabel}>Public DNC</span>
                    </div>
                  ) : (
                    <div
                      className={classNames(
                        css.myDncToggle,
                        hasMyDNC ? css.myDncToggleOn : css.myDncToggleOff,
                      )}
                      onClick={handleToggleMyDNC}
                    >
                      <span className={css.myDncLabel}>myDNC</span>
                      <span className={css.myDncSwitch}>
                        <span className={css.myDncSwitchCircle} />
                      </span>
                    </div>
                  )}
                  {pabEnabled && hasPAB ? (
                    <div className={css.pabPill}>PAB</div>
                  ) : null}
                </div>
              );
            })()}
            <img
              className={css.icon}
              style={{ marginLeft: "auto" }}
              src={remove}
              alt="remove"
              onClick={() => this.handleRemove(seq)}
              onMouseEnter={(e) => { e.currentTarget.src = removeHover; }}
              onMouseLeave={(e) => { e.currentTarget.src = remove; }}
              onMouseDown={(e) => { e.currentTarget.src = removePressed; }}
              onMouseUp={(e) => { e.currentTarget.src = removeHover; }}
            />
          </div>
        )})}
      </div>
    );
  }
}


ContactItems.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  field: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  types: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  pabEnabled: PropTypes.bool,
};

export default ContactItems;
